import UserManagement from "../../../components/Setting/UserManagement";
import React, { useState, useEffect, useMemo } from "react";
import { Image, Tooltip } from "antd";
import menu from "../../../assets/Images/menudots.svg";
import plus from "../../../assets/Images/plus.svg";
import noImage from "../../../assets/Images/roundimage.png";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import { Empty } from "antd";
import "tailwindcss/tailwind.css";
import { Dropdown } from "antd";
import AddUser from "../../../components/Setting/AddUser";
import { Breadcrumb } from "antd";
import {
  DoubleRightOutlined,
  DeleteOutlined,
  EditOutlined,
  StopOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import Sidebar from "../../../components/SideBar/sidebar";
import Navbar from "../../../components/Navbar/Navbar";
import { routes } from "../../../Routes";
import {
  blockStoreUser,
  getStoreUsers,
} from "../../../API  Functions/UserMangement";
import { useSelector } from "react-redux";
import Blockuserpopup from "../../../modals/Blockuserpopup";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading";
import { toast } from "react-toastify";
import {
  GetRetailerDetails,
  getSubstores,
} from "../../../API  Functions/ProfileFunctions";
import { checkPermission } from "../../../Utils/permissionHelper";
import SearchBox from "../../../components/CustomWidgets/SearchBox";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";
// Dropdown data array

//

const Setting = () => {
  const { t, i18n } = useTranslation();
  // const user_id = useSelector((state) => state.login?.user?.user_id);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((state) => state.login?.user?.store_id);
  const store_data = useSelector((state) => state.login?.user?.result);
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  // This is for use in add user button to open a new component
  const [showComponent, setShowComponent] = useState(false);
  const [storeuser, setstoreuser] = useState(null);

  const [popup, setpopup] = useState(false);
  const [blockdata, setblockdata] = useState([]);
  const [status, setstatus] = useState(1);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [retailerData, setretailerData] = useState({});
  const [allUsers, setAllUsers] = useState([]); //  backup for search

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );
  const [subStores, setSubStores] = useState([]);
  const masterStore = useSelector((state) => state.login.masterStore);

  const [noOfUserLimit, setNoOfUserLimit] = useState(0);
  const [noOfUserCreated, setNoOfUserCreated] = useState(0);
  const [currentLimit, setCurrentLimit] = useState(10);
  const [currentOffset, setCurrentOffset] = useState(0);
  useEffect(() => {
    console.log("ALLL STORE", allStores);

    if (allStores || masterStore) {
      getSubStoresData();
    }
  }, [allStores]);

  const getSubStoresData = () => {
    getSubstores(masterStore?.store_id).then((res) => {
      console.log("USERRRRR---> Res", res);

      setSubStores(res?.response);
    });
  };
  const paginatedData = useMemo(() => {
    return data.slice(currentOffset, currentOffset + currentLimit);
  }, [data, currentOffset, currentLimit]);
  const getStoreusers = () => {
    setLoading(true);
    getStoreUsers(user_id)
      .then((res) => {
        if (res?.result[0]?.status_code === 200) {
          const users = res.result[0]?.response;

          // ✅ SORT: active first, then inactive
          const sortedUsers = (users || []).sort(
            (a, b) => Number(b.active) - Number(a.active),
          );

          setData(sortedUsers);
          setAllUsers(sortedUsers);

          setNoOfUserLimit(res.result[0]?.no_of_user || 0);
          setNoOfUserCreated(res.result[0]?.no_of_user_created || 0);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    fetchdetails();
    getStoreusers();
  }, []);

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setretailerData(result?.retailer_details);
      }
    });
  };
  const blockstoreuser = async (val, block) => {
    const response = await blockStoreUser(user_id, val?.retailer_user_id);
    if (response?.data?.result[0]?.status === "Retailer User Deactivated") {
      setstatus(block);
      setblockdata(val);
      setpopup(true);
      getStoreusers();
    } else if (
      response?.data?.result[0]?.status ===
      "Please close the POS session for this user"
    ) {
      toast.error("Please close the POS session for this user");
    }
  };

  const searchUser = (searchText) => {
    if (!searchText || searchText.trim() === "") {
      setData(allUsers); // reset when empty
      return;
    }

    const text = searchText.toLowerCase();

    const filteredUsers = allUsers.filter((user) => {
      const name =
        typeof user?.name === "string" ? user.name.toLowerCase() : "";
      const email =
        typeof user?.email === "string" ? user.email.toLowerCase() : "";
      const phone =
        typeof user?.phone === "string" ? user.phone.toLowerCase() : "";

      return (
        name.includes(text) || email.includes(text) || phone.includes(text)
      );
    });

    setData(filteredUsers);
  };
  const pagination = ({ limit, offset }) => {
    setCurrentLimit(limit);
    setCurrentOffset(offset);
  };
  const columns = useMemo(
    () => [
      {
        Header: t("User"),
        accessor: "name",
        width: "20%",
        Cell: ({ row }) => {
          const val = row.original;
          return (
            <div className="flex items-center gap-3">
              <img
                className="h-8 w-8 object-cover rounded-full"
                src={val?.image_url?.length >= 30 ? val.image_url : noImage}
                alt=""
              />
              <span className="font-medium">{val.name}</span>
            </div>
          );
        },
      },

      //  CONTACT
      {
        Header: t("Mobile Number"),
        accessor: "contact",
        width: "15%",
        Cell: ({ row }) => {
          const val = row.original;
          return (
            <div className="text-start">
              {val.phone ? val.phone : val.email}
            </div>
          );
        },
      },

      //  ROLE
      {
        Header: t("permission"),
        accessor: "user_type",
        width: "15%",
        Cell: ({ row }) => (
          <div className="text-start">{t(row.original.user_type)}</div>
        ),
      },

      //  LAST LOGIN
      {
        Header: t("Last Login"),
        accessor: "last_login",
        width: "15%",
        Cell: ({ row }) => (
          <div className="text-start">
            {row.original.last_login ? `${row.original.last_login}` : "-"}
          </div>
        ),
      },
      //  STATUS
      {
        Header: t("Status"),
        accessor: "status",
        width: "15%",
        Cell: ({ row }) => {
          const isActive = row.original.active;

          return (
            <div className="text-start">
              <span
                className={`px-3 py-1 rounded-full text-xs font-semibold border ${
                  isActive
                    ? "bg-green-100 text-green-700 border-green-300"
                    : "bg-red-100 text-red-600 border-red-300"
                }`}
              >
                {isActive ? t("Active") : t("Deactivated")}
              </span>
            </div>
          );
        },
      },

      //  STORE (Conditional)
      ...(allStores
        ? [
            {
              Header: t("Store"),
              accessor: "store_name",
              width: "15%",
              Cell: ({ row }) => (
                <div className="text-start font-semibold">
                  {row.original.store_name}
                </div>
              ),
            },
          ]
        : []),

      //  ACTIONS
      {
        Header: t("Actions"),
        accessor: "actions",
        width: "20%",
        Cell: ({ row }) => {
          const val = row.original;

          return (
            <div className="text-start">
              {val.active && (
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: "1",
                        icon: <EditOutlined />,
                        label: t("edit"),
                        onClick: () => {
                          setstoreuser(val);
                          setShowComponent(true);
                        },
                      },
                      { type: "divider" },
                      ...(val?.user_type !== "admin"
                        ? [
                            {
                              key: "2",
                              icon: <StopOutlined />,
                              label: val.active
                                ? t("Deactivate")
                                : t("unblock"),
                              onClick: () => {
                                if (
                                  !checkPermission(
                                    "/settings/usermanagement",
                                    isGinne,
                                  )
                                ) {
                                  return;
                                }
                                blockstoreuser(val, val.active ? 0 : 1);
                              },
                            },
                          ]
                        : []),
                    ],
                  }}
                  trigger={["click"]}
                >
                  <img src={menu} alt="menu" className="cursor-pointer" />
                </Dropdown>
              )}

              {!val.active && (
                <span className="text-red-500 text-xs">{t("")}</span>
              )}
            </div>
          );
        },
      },
    ],
    [t, allStores],
  );
  const {
    headerGroups,
    prepareRow,
    page,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: paginatedData,
      initialState: { pageSize: currentLimit },
      manualPagination: true, // 🔥 IMPORTANT (server-side)
      pageCount: Math.ceil((data?.length || 0) / currentLimit),
    },
    useSortBy,
    usePagination,
    useRowSelect,
  );

  // const [pageIndex, setpageIndex] = useState(1);
  const pageIndex = Math.floor(currentOffset / currentLimit) + 1;
  useEffect(() => {
    const pageDetails = {
      limit: currentLimit,
      offset: currentOffset,
    };

    pagination(pageDetails);
  }, [currentLimit, currentOffset]);

  return (
    <>
      {loading && <LoadingSpinner />}
      <Navbar heading="user_management" />
      <div className="w-full flex flex-col pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <div className="overflow-y-auto custom-scrollbar">
          <div className="me-4 ms-3 font-extrabold">
            {retailerData?.status == "approved" ? (
              <>
                {showComponent ? (
                  <AddUser
                    onClose={() => {
                      setShowComponent(false);
                      setstoreuser(null);
                      getStoreusers();
                    }}
                    isEdit={storeuser}
                    subStores={subStores}
                  />
                ) : (
                  <>
                    <div className="flex flex-row items-end justify-between mb-4">
                      <div className="mt-3 ms-2">
                        {data?.length > 0 && (
                          <div className="font-semibold text-xl flex items-center gap-2">
                            {t("allusers")}

                            <span className="text-l">{`(${noOfUserCreated}/${noOfUserLimit})`}</span>

                            <Tooltip
                              title={t(
                                "Created users out of total limit (excluding admin users)",
                              )}
                            >
                              <InfoCircleOutlined className="text-gray-500 cursor-pointer text-sm" />
                            </Tooltip>
                          </div>
                        )}
                      </div>
                      <SearchBox
                        searchResult={(values) => searchUser(values)}
                        placeholder={t("Search Users")}
                      />

                      <div className="flex justify-between items-center">
                        <div className="font-semibold text-xl mt-2 ">
                          {/* {t("admin")} */}
                        </div>
                        <button
                          onClick={() => {
                            if (
                              checkPermission(
                                "/settings/usermanagement",
                                isGinne,
                              )
                            ) {
                              setShowComponent(true);
                            }
                          }}
                          className={`font-semibold w-40 mt-5  h-10 border  rounded-lg bg-primaryBlue text-white text-base   flex justify-center items-center gap-2`}
                          type="submit"
                        >
                          <img src={plus} alt="plus" />
                          <p className="">{t("Add User")}</p>
                        </button>
                      </div>
                    </div>

                    <div className="overflow-x-auto scrollbar-none ">
                      <div className="inline-block min-w-full align-middle">
                        <div className="overflow-hidden border rounded-lg">
                          <div className="max-h-[600px] overflow-y-auto scrollbar-none">
                            <table
                              className="font-normal min-w-[1200px] w-full border-collapse table-fixed"
                              style={{ tableLayout: "fixed" }}
                            >
                              {/* ✅ HEADER */}
                              <thead className="bg-[#78CFEC66] text-sm font-semibold whitespace-nowrap sticky top-0 z-10">
                                {headerGroups.map((headerGroup) => {
                                  const {
                                    key: headerKey,
                                    ...headerGroupProps
                                  } = headerGroup.getHeaderGroupProps();

                                  return (
                                    <tr key={headerKey} {...headerGroupProps}>
                                      {headerGroup.headers.map((column) => {
                                        const {
                                          key: columnKey,
                                          ...columnProps
                                        } = column.getHeaderProps(
                                          column.getSortByToggleProps(),
                                        );

                                        return (
                                          <th
                                            key={columnKey}
                                            {...columnProps}
                                            className="py-3 px-2 text-left"
                                            style={{
                                              width: column.width,
                                              minWidth: column.width,
                                              maxWidth: column.width,
                                            }}
                                          >
                                            <div className="flex items-center gap-1">
                                              {column.render("Header")}

                                              {column.isSorted ? (
                                                column.isSortedDesc ? (
                                                  <img
                                                    src={Vectorsorting}
                                                    style={{
                                                      minHeight: 10,
                                                      minWidth: 10,
                                                    }}
                                                    alt="vector"
                                                  />
                                                ) : (
                                                  <img
                                                    className="rotate-180"
                                                    src={Vectorsorting}
                                                    alt="vector"
                                                  />
                                                )
                                              ) : null}
                                            </div>
                                          </th>
                                        );
                                      })}
                                    </tr>
                                  );
                                })}
                              </thead>

                              {/* ✅ BODY */}
                              <tbody className="bg-[#F7F9FD] text-center">
                                {page.map((row) => {
                                  prepareRow(row);

                                  return (
                                    <tr
                                      key={row.id}
                                      {...row.getRowProps()}
                                      className="hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300"
                                    >
                                      {row.cells.map((cell, index) => (
                                        <td
                                          key={index}
                                          {...cell.getCellProps()}
                                          className="p-2 text-[#272728] text-sm font-normal text-left"
                                          style={{
                                            width: cell.column.width,
                                            minWidth: cell.column.width,
                                            maxWidth: cell.column.width,
                                          }}
                                        >
                                          {cell.render("Cell")}
                                        </td>
                                      ))}
                                    </tr>
                                  );
                                })}

                                {/* ✅ EMPTY STATE */}
                                {page.length === 0 && (
                                  <tr>
                                    <td colSpan={"100%"}>
                                      <Empty
                                        className="mt-10"
                                        description={t("No data available")}
                                      />
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Pagination */}
                    <div>
                      <CustomPagination
                        data={data?.length}
                        pageIndex={pageIndex}
                        pageCount={Math.ceil(data.length / currentLimit)}
                        canPreviousPage={currentOffset > 0}
                        canNextPage={currentOffset + currentLimit < data.length}
                        previousPage={() =>
                          setCurrentOffset((prev) =>
                            Math.max(0, prev - currentLimit),
                          )
                        }
                        nextPage={() =>
                          setCurrentOffset((prev) => prev + currentLimit)
                        }
                        gotoPage={(page) =>
                          setCurrentOffset((page - 1) * currentLimit)
                        }
                        pageSize={currentLimit}
                        setPageSize={(size) => {
                          setCurrentLimit(size);
                          setCurrentOffset(0);
                          setPageSize(size);
                        }}
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div className="flex justify-center w-full mt-16 text-sm text-body text-center p-3 font-normal ">
                  {retailerData?.status && retailerData?.status != "approved"
                    ? t(
                        "You cannot add or update user settings until your store is approved by myGINNE.",
                      )
                    : ""}
                </div>
              </>
            )}
            {popup && (
              <Blockuserpopup
                onClose={() => setpopup(false)}
                data={blockdata}
                status={status}
              />
            )}
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default Setting;
